module.exports = __webpack_public_path__ + "img/service_point.15491b8.webp";